export default __webpack_public_path__ + "static/Timeline-343f98299ab3dbf0b0af302df1c349aa.png";